<template>
  <div class="rule-container">
    <div class="page">
      <el-form :model="campusRules" ref="ruleForm" :rules="formRules">
        <div class="rule-item get-scene">
          <div class="title">星币获取场景</div>
          <div class="content">
            <el-checkbox-group v-model="starGetTypes.value">
              <el-checkbox v-for="typeItem in starGetTypes.list" :key="typeItem.value" :label="typeItem.value">{{ typeItem.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('classGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            上课规则设置
          </h2>
          <!-- 奖励标签 -->
          <div class="rule-item">
            <div class="title">标签奖励数量</div>
            <div class="content">
              <div class="content-item" v-for="(input, index) in campusRules.awardTags" :key="input.id">
                <el-form-item :prop="'awardTags.' + index + '.name'" :label="
                      `标签${
                        index === 0
                          ? '一'
                          : index === 1
                          ? '二'
                          : index === 2
                          ? '三'
                          : '四'
                      }`
                    " :class="[
                      `custom-item-style-${index + 1}`,
                      input.hide ? 'hide' : '',
                    ]" :rules="[
                      {
                        required: true,
                        message: '请输入标签名',
                        trigger: 'blur',
                      },
                      {
                        min: 1,
                        max: 6,
                        message: '请限制6字以内',
                        trigger: 'blur',
                      },
                    ]">
                  <el-input size="small" placeholder="请输入名称(例:纪律标兵),限制6字以内" style="min-width: 150px;" v-model="input.name" oninput="value=value.replace(/\s+/g, '')" :disabled="input.hide">
                    <template slot="suffix">
                      <i style="display: flex;align-items: center;height: 100%;cursor: pointer;" @click="methodToggleTag(input)">
                        <!-- 显示svg -->
                        <svg v-if="!input.hide" t="1723081049849" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3152" width="20" height="20">
                          <path d="M511.999488 252.461919c-174.547385 0-324.652078 108.241236-384.02942 261.84973 59.377342 153.60747 209.481012 261.84973 384.02942 261.84973 174.551478 0 324.70529-108.241236 384.02942-261.84973C836.703755 360.702132 686.550966 252.461919 511.999488 252.461919M511.999488 688.862103c-97.731882 0-174.547385-76.767408-174.547385-174.550455 0-97.782024 76.815503-174.551478 174.547385-174.551478 97.785094 0 174.551478 76.769454 174.551478 174.551478C686.550966 612.094696 609.784582 688.862103 511.999488 688.862103M511.999488 409.573189c-59.32413 0-104.737436 45.413306-104.737436 104.738459 0 59.328223 45.413306 104.739483 104.737436 104.739483 59.377342 0 104.740506-45.412282 104.740506-104.739483C616.739994 454.986495 571.376831 409.573189 511.999488 409.573189" p-id="3153"></path>
                        </svg>
                        <!-- 隐藏svg -->
                        <svg v-else t="1723084862729" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3380" width="18" height="18">
                          <path d="M931.37 477.14c-43.94-69.49-93.39-125.03-147.99-166.35L663.31 441.46c8.79 21.36 13.63 44.91 13.63 69.62 0 96.27-73.84 174.32-164.95 174.32-21.63 0-42.28-4.39-61.32-12.47l-94.09 102.52a455.097 455.097 0 0 0 155.41 26.2c172.62 0 312.43-85.54 419.59-256.63 12.83-20.43 12.72-47.45-0.21-67.88zM795.52 127.99L682.24 252.82C627.73 231 570.1 220.04 512.11 220.5c-171.15 0-310.99 85.66-419.48 256.75-12.93 20.43-13.04 47.33-0.2 67.78 46.95 75.15 100.3 133.68 160.01 175.82L131.9 853.65l38.9 42.36 663.6-725.76-38.88-42.26zM519.68 438.37c-3.72-0.59-7.46-0.81-11.27-0.81-45.63 0-82.43 39.03-82.43 87.16 0 4.97 0.42 9.81 1.14 14.54l-57.15 60.14-5.92 8.33c-13.15-24.94-20.5-53.68-20.5-84.28 0-96.3 73.84-174.45 164.95-174.45 27.2 0 52.76 6.93 75.4 19.29l-64.22 70.08z m52.05 135.53c21.74-23.26 27.17-55.48 16.31-81.39l-96.42 103.16c26.59 9.08 58.38 1.48 80.11-21.77z" fill="#333333" p-id="3381"></path>
                        </svg>
                      </i>
                    </template>
                  </el-input>
                </el-form-item>
                <div class="content-item-list" v-if="
                      input.hide === false && input.awardStarNum.join('') !== ''
                    ">
                  <el-form-item v-for="(numItem, numIndex) in input.awardStarNum" :key="numIndex" :prop="'awardTags.' + index + '.awardStarNum.' + numIndex" :rules="[
                        {
                          trigger: ['blur', 'change'],
                          validator: validAwardStarNum,
                        },
                      ]">
                    <el-input-number v-model="input.awardStarNum[numIndex]" :precision="0" @change="methodCheckNum($event, numIndex)" label="请输入数量" size="small"></el-input-number>
                  </el-form-item>
                  <span>
                    <!-- 注：大于0时，则为加星币；小于0时，则为扣除星币 -->
                    注：星币为负数时，则为扣除星币
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 老师奖励数量 -->
          <div class="rule-item">
            <div class="title">最大发放数量</div>
            <div class="content">
              <el-form-item>
                <el-input-number :precision="0" v-model="campusRules.teachAwardNum" label="请输入数量" size="small" :min="0"></el-input-number>
              </el-form-item>
              <span>注：每节课每个学生奖励星币的最大数量
                <i>若大于0则进行限制，反之则不限制</i></span>
            </div>
          </div>
        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('examGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            考试规则设置
          </h2>
          <!-- 老师奖励数量 -->
          <div class="rule-item">
            <div class="title">最大发放数量</div>
            <div class="content">
              <el-form-item>
                <el-input-number :precision="0" v-model="examAwardRule" label="请输入数量" size="small" :min="0"></el-input-number>
              </el-form-item>
              <span>注：每场考试奖励星币的最大数量
                <i>若大于0则进行限制，反之则不限制</i></span>
            </div>
          </div>
        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('reviewGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            课堂点评规则设置
          </h2>
          <!-- 老师奖励数量 -->
          <div class="rule-item">
            <div class="title">最大发放数量</div>
            <div class="content">
              <el-form-item>
                <el-input-number :precision="0" v-model="classroomCreateRule" label="请输入数量" size="small" :min="0"></el-input-number>
              </el-form-item>
              <span>注：奖励星币的最大数量
                <i>若大于0则进行限制，反之则不限制</i></span>
            </div>
          </div>
        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('attendGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            点名签到规则设置
          </h2>
          <!-- 星币奖励 -->
          <div class="rule-item">
            <div class="title">发放数量</div>
            <div class="content">
              <el-form-item>
                <el-input-number :precision="0" v-model="signStarAward" label="请输入数量" size="small" :min="0"></el-input-number>
              </el-form-item>
              <span>注：点名出勤，获得星币数量 <i>默认为0时，不发放星币</i></span>
            </div>
          </div>
        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('shareReportGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            分享学习报告规则设置
          </h2>
          <!-- 星币奖励 -->
          <!-- <div class="rule-item-box-flex">
              <div class="rule-item">
                <div class="title">集赞数量</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="shareStudyRules.collectLikes" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：输入集赞数量</span>
                </div>
              </div>
              <div class="rule-item">
                <div class="title">获得星币数量</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="shareStudyRules.starAward" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：输入获得星币数量 <i>默认为0时，不发放星币</i></span>
                </div>
              </div>
            </div> -->
          <h1>规则一</h1>
          <div class="rule-item-box-flex">
            <div class="operation-radio">
              <el-radio v-model="campusRules.shareStudyRules.shareReportType" :label="0" @input="handleChangeShareType">
              </el-radio>
            </div>
            <div class="rule-item-cell">
              <div class="rule-item">
                <div class="title">集够赞数量</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="campusRules.shareStudyRules.collectLikes" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：输入集赞数量</span>
                </div>
              </div>
              <div class="rule-item">
                <div class="title">获得星币数量</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="campusRules.shareStudyRules.starAward" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：完成目标后，可获得的星币数 <i>默认为0时，不发放星币</i></span>
                </div>
              </div>
            </div>
          </div>
          <el-divider />
          <h1>规则二</h1>
          <div class="rule-item-box-flex" style="paddingBottom:20px">
            <div class="operation-radio">
              <el-radio v-model="campusRules.shareStudyRules.shareReportType" :label="1" @input="handleChangeShareType">
              </el-radio>
            </div>
            <div class="rule-item-cell">
              <div class="rule-item">
                <div class="title">集赞数量</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="campusRules.shareStudyRules.shareReportRepeatZanNum" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：输入目标集赞数量</span>
                </div>
              </div>
              <div class="rule-item">
                <div class="title">获得星币数量</div>
                <div class="content">
                  <el-form-item prop="shareStudyRules.shareReportRepeatReward">
                    <el-input-number :precision="0" v-model="campusRules.shareStudyRules.shareReportRepeatReward" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：完成目标后，可获得的星币数 <i>默认为0时，不发放星币</i></span>
                </div>
              </div>
              <div class="rule-item">
                <div class="title">最多获得星币</div>
                <div class="content">
                  <el-form-item>
                    <el-input-number :precision="0" v-model="campusRules.shareStudyRules.shareReportRepeatLimit" label="请输入数量" size="small" :min="0"></el-input-number>
                  </el-form-item>
                  <span>注：学生获得的星币数量 <i></i></span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="rule-item-box" v-if="starGetTypes.value.includes('ojProblemGrant')">
          <!-- <el-divider></el-divider> -->
          <h2 style="font-size: 14px;padding: 20px">
            信奥专区刷题规则设置
          </h2>
          <!-- 星币奖励 -->
          <div class="rule-item">
            <div class="title">发放数量</div>
            <div class="content">
              <el-form-item>
                <el-input-number :precision="0" v-model="ojProblemReward" label="请输入数量" size="small" :min="0"></el-input-number>
              </el-form-item>
              <span>注：提交成功后，获得星币 <i>默认为0时，不发放星币</i></span>
            </div>
          </div>
        </div>
      </el-form>
      <div class="operation">
        <el-button type="primary" size="small" @click="schoolEduCampusTagEdit">保 存</el-button>
        <!-- <el-button type="cancel" size="small" @click="resetQuery"
          >重 置</el-button
        > -->
      </div>
    </div>
  </div>
</template>
<script>
// 引入请求
import {
  api_schoolEduCampusCheck,
  api_schoolEduCampusTagEdit,
  api_schoolRuleTagHide,
} from '@/api/javaApi'
export default {
  name: 'rulesSetting',
  props: ['campusData'],
  data() {
    return {
      starGetTypes: {
        value: [],
        list: [
          /**
           *classGrant:false, // 上课发放
            examGrant:false, // 考试发放
            reviewGrant:false, // 课堂点评发放
            attendGrant:false, // 出勤发放
           */
          { label: '上课', value: 'classGrant' },
          { label: '考试', value: 'examGrant' },
          {
            label: '课堂点评',
            value: 'reviewGrant',
          },
          { label: '点名签到', value: 'attendGrant' },
          { label: '分享学习报告', value: 'shareReportGrant' },
          { label: '信奥专区刷题', value: 'ojProblemGrant' },
        ],
      },
      formQuery: {
        eduCampusId: null,
      },
      resetCampusRules: {
        awardTags: [
          {
            id: 1,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第一个
          {
            id: 2,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第二个
          {
            id: 3,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第三个
          {
            id: 4,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第四个
        ],
        teachAwardNum: 0,
      },
      // 上课奖励规则设置
      campusRules: {
        awardTags: [
          {
            id: 1,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第一个
          {
            id: 2,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第二个
          {
            id: 3,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第三个
          {
            id: 4,
            name: '',
            hide: false,
            awardStarNum: [null, null, null, null, null],
          }, // 第四个
        ],
        teachAwardNum: 0,
        // 分享学习报告奖励
        shareStudyRules: {
          collectLikes: 0,
          starAward: 0,
          shareReportType: 1,
          shareReportRepeatZanNum: 0,
          shareReportRepeatReward: 0,
          shareReportRepeatLimit: 0,
        },
      },
      // 考试奖励规则设置
      examAwardRule: 0,
      // 课堂创作规则设置
      classroomCreateRule: 0,
      // 点名签到奖励
      signStarAward: 0,
      // 信奥专区刷题发放星币
      ojProblemReward: 0,
      formRules: {} // 初始化为空，我们将在 methods 中填充它
    }
  },
  created() {
    this.methodSearch()
    this.generateFormRules()
  },
  methods: {
    generateFormRules() {
      this.formRules = {
        'shareStudyRules.shareReportRepeatReward': [
          { validator: this.validateNum, trigger: ['blur', 'input', 'change'] },
          { type: 'number', message: '请输入数量' }
        ]
      };
    },
    validateNum(rule, value, callback) {
      // this.starGetTypes.value.includes('shareReportGrant')
      console.log('this.campusRules')
      console.log(this.campusRules)
      if (value > this.campusRules.shareStudyRules.shareReportRepeatLimit) {
        callback(new Error('获得星币数量不能大于最多获得数量!'));
      } else {
        callback();
      }
    },
    validAwardStarNum(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入数量'))
      } else if (value === 0) {
        callback(new Error('不能输入0'))
      } else {
        callback()
      }
    },
    methodCheckNum(value, index) {
      console.log(value, index)
      // 使用正则表达式来判断是否为正整数
      // const regex = /^[1-9]\d*$/
      // // 如果输入的值不符合正整数的正则表达式，则将其设置为上一个有效值
      // if (value.includes(' ')) {
      //   return (this.campusRules.starAwardTags[index].num = value.replace(
      //     /\s+/g,
      //     ''
      //   ))
      // }
      // if (!regex.test(value)) {
      //   this.campusRules.starAwardTags[index].num =
      //     value === '0'
      //       ? this.campusRules.starAwardTags[index].num.substring(
      //           0,
      //           this.campusRules.starAwardTags[index].num.length - 1
      //         )
      //       : this.campusRules.starAwardTags[index].num.replace(/\D/g, '')
      // }
    },
    // 查询
    methodSearch() {
      this.formQuery.eduCampusId = this.campusData[0]
      this.schoolEduCampusCheck()
    },
    // 重置查询参数
    resetQuery() {
      // this.formQuery = {
      //   ...this.formQuery,
      //   ...{
      //     stuName: '',
      //     productName: '',
      //     productCategory: null,
      //     productState: null,
      //     time: null,
      //     orderNumber: '',
      //   },
      // }
      // this.tableData = []
      // this.campusRules = window.JSON.parse(
      //   window.JSON.stringify(this.resetCampusRules)
      // )
      // Object.assign(this.$data, this.$options.data()) // 这一句会产生校验不了的bug
      this.methodSearch()
    },
    // 查看规则设置
    schoolEduCampusCheck() {
      api_schoolEduCampusCheck({
        eduCampusId: this.formQuery.eduCampusId, // 校区Id
      }).then((res) => {
        console.log(res)
        if (res) {
          if (res.ruleTagList.join('') !== '') {
            this.campusRules.awardTags = []
            res.ruleTagList.forEach((item) => {
              this.campusRules.awardTags.push({
                id: item.id,
                name: item.name,
                hide: item.hide,
                awardStarNum: item.awardStarNum.split(','),
              })
            })
          }
          this.campusRules.teachAwardNum = res.classRoomRewardRule // 上课 - 老师奖励数量
          this.examAwardRule = res.examRewardRule // 考试 - 老师奖励数量
          this.classroomCreateRule = res.lectureWorkRewardRule // 课堂创作 - 老师奖励数量
          this.signStarAward = res.attendReward // 点名签到 - 老师奖励数量
          this.ojProblemReward = res.ojProblemReward // 信奥专区刷题 - 老师奖励数量
          this.campusRules.shareStudyRules.collectLikes = res.shareReportZanNum // 分享报告-集赞数量
          this.campusRules.shareStudyRules.starAward = res.shareReportReward // 分享报告 - 奖励数量
          this.campusRules.shareStudyRules.shareReportType = res.shareReportType // 学习报告星币发放模式
          this.campusRules.shareStudyRules.shareReportRepeatZanNum = res.shareReportRepeatZanNum // 学习报告重复集赞数
          this.campusRules.shareStudyRules.shareReportRepeatReward = res.shareReportRepeatReward // 学习报告重复奖励数
          this.campusRules.shareStudyRules.shareReportRepeatLimit = res.shareReportRepeatLimit // 学习报告重复奖励数上限
          this.starGetTypes.list.forEach((item) => {
            for (const key in res) {
              if (key === item.value && res[key]) {
                this.starGetTypes.value.push(key)
              }
            }
          })
        }
      })
    },
    // 编辑规则设置
    schoolEduCampusTagEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let awardRules = window.JSON.parse(
            window.JSON.stringify(this.campusRules.awardTags)
          )
          awardRules.forEach((item) => {
            item.awardStarNum = item.awardStarNum.join(',')
          })
          api_schoolEduCampusTagEdit({
            tagList: awardRules, // 标签组
            // awardStarNum: awardStarNumList.join(), // 标签奖励星币数
            classRoomRewardRule: this.campusRules.teachAwardNum, // 上课 - 老师奖励数量
            examRewardRule: this.examAwardRule, // 考试 - 老师奖励数量
            lectureWorkRewardRule: this.classroomCreateRule, // 课堂创作 - 老师奖励数量
            attendReward: this.signStarAward, // 点名签到 - 老师奖励数量
            ojProblemReward: this.ojProblemReward, // 信奥专区刷题 - 老师奖励数量
            shareReportZanNum: this.campusRules.shareStudyRules.collectLikes,// 分享报告-集赞数量
            shareReportReward: this.campusRules.shareStudyRules.starAward,// 分享报告-奖励数量
            shareReportType: this.campusRules.shareStudyRules.shareReportType, // 学习报告星币发放模式
            shareReportRepeatZanNum: this.campusRules.shareStudyRules.shareReportRepeatZanNum, // 学习报告重复集赞数
            shareReportRepeatReward: this.campusRules.shareStudyRules.shareReportRepeatReward, // 学习报告重复奖励数
            shareReportRepeatLimit: this.campusRules.shareStudyRules.shareReportRepeatLimit, // 学习报告重复奖励数上限
            eduCampusId: this.formQuery.eduCampusId,
            updater: this.$store.state.user.userInfo.id,
            classGrant: this.starGetTypes.value.includes('classGrant'),
            examGrant: this.starGetTypes.value.includes('examGrant'),
            reviewGrant: this.starGetTypes.value.includes('reviewGrant'),
            attendGrant: this.starGetTypes.value.includes('attendGrant'),
            ojProblemGrant: this.starGetTypes.value.includes('ojProblemGrant'),
            shareReportGrant: this.starGetTypes.value.includes('shareReportGrant'),
          }).then((res) => {
            console.log(res)
            this.$message.success('保存成功')
            this.resetQuery()
          })
        } else {
          return false
        }
      })
    },
    // 设置标签隐藏显示
    methodToggleTag(input) {
      let hideLength = this.campusRules.awardTags.filter((item) => item.hide)
        .length
      if (!input.hide && hideLength >= 2) {
        return this.$message.warning('最多可隐藏两个标签')
      }
      api_schoolRuleTagHide({
        ruleTagId: input.id,
        hide: !input.hide,
      }).then((res) => {
        console.log('api_schoolRuleTagHide---res:', res)
        this.$message.success('设置成功')
        this.methodSearch()
      })
    },
    handleChangeShareType(val) {
      console.log(val);
    },
  },
}
</script>
<style scoped lang="scss">
.rule-container {
  width: 100%;
  height: 100%;
  .page {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // padding: 20px 30px;
    // background: #ffffff;
    // box-shadow: 0px 0px 4px 0px #f0f4f5;
    // border-radius: 5px;
    // border: 1px solid #f4f5f9;
    .el-form {
      margin-bottom: 10px;
      .rule-item-box {
        background-color: #fff;
        border-radius: 5px;
        h1 {
          padding-left: 20px;
          font-size: 18px;
        }
        .el-divider {
          height: 5px !important;
          margin-bottom: 20px;
          background-color: #f9f9f9;
        }
      }
      .rule-item-box-flex {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;
        margin-bottom: 10px;
        .operation-radio {
          position: absolute;
          padding-top: 18px;
          .el-radio {
            /deep/ .el-radio__label {
              visibility: hidden;
            }
          }
        }
        .rule-item-cell {
          display: flex;
          flex-wrap: wrap;
        }
      }
      .rule-item {
        display: flex;
        // align-items: center;
        flex-wrap: wrap;
        padding: 0 20px;
        min-height: 52px;
        background-color: #fff;
        margin-bottom: 10px;
        border-radius: 5px;
        .el-radio {
          display: flex;
          align-items: center;
          .el-radio__input {
            display: flex;
          }
        }
        .title {
          width: 100px;
          height: 52px;
          padding-top: 16px;
          color: #333;
          font-size: 14px;
          font-weight: bold;
          line-height: 22px;
        }
        &.get-scene {
          color: #000000;
          font-size: 16px;
        }
        .content {
          flex: 1;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .content-item {
            display: flex;
            align-items: flex-end;
            flex-wrap: wrap;
            width: 100%;
            .content-item-list {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
          }
          .el-form-item {
            margin-bottom: 0;
            margin-right: 10px;

            &.custom-item-style-1 /deep/ {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    color: #53a6ff;
                    background-color: #ecf5ff;
                    border-color: #daecff;
                    &::placeholder {
                      color: rgba(83, 166, 255, 0.7);
                    }
                  }
                }
              }
            }
            &.custom-item-style-2 /deep/ {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    color: #76c74c;
                    background-color: #f0f9eb;
                    border-color: #e1f3d8;
                    &::placeholder {
                      color: rgba(118, 199, 76, 0.7);
                    }
                  }
                }
              }
            }
            &.custom-item-style-3 /deep/ {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    color: #e9a94f;
                    background-color: #fdf6ec;
                    border-color: #f3e4ce;
                    &::placeholder {
                      color: rgba(233, 169, 79, 0.7);
                    }
                  }
                }
              }
            }
            &.custom-item-style-4 /deep/ {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    color: #f56c6c;
                    background-color: #ffeff0;
                    border-color: #fee2e1;
                    &::placeholder {
                      color: rgba(245, 108, 108, 0.7);
                    }
                  }
                }
              }
            }
            &.hide /deep/ {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    // color: #53a6ff;
                    // background-color: #ecf5ff;
                    // border-color: #daecff;
                    opacity: 0.4;
                    &::placeholder {
                      opacity: 0.5;
                    }
                  }
                }
              }
            }
          }
          span {
            display: flex;
            align-items: center;
            font-size: 14px;
            i {
              padding-left: 10px;
              font-style: normal;
              font-size: 12px;
            }
          }
          .radio-btn {
            box-sizing: border-box;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            min-width: 124px;
            height: 42px;
            padding: 0 15px;
            margin-right: 35px;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #1678ff;
            font-weight: 400;
            font-size: 18px;
            color: #0a1629;
            transition: all 0.25s;
            cursor: pointer;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              background-color: #1678ff;
              color: #fff;
            }
            &:hover {
              background-color: #1678ff;
              color: #fff;
            }
          }
          .el-radio {
            // margin-bottom: 10px;
          }
          .el-input {
            // margin-right: 20px;
            // margin-bottom: 10px;
          }
        }
      }
      .el-divider {
        margin: 15px 0;
      }
    }
    .operation {
      position: sticky;
      bottom: 0;
      z-index: 1;
      display: flex;
      justify-content: flex-end;
      padding: 10px 20px;
      background-color: #fff;
      box-shadow: inset 0px 1px 0px 0px #ebedf0;
    }
  }
}
</style>
